module.exports = __webpack_public_path__ + "img/mosqu-logo.13a17f60.png";